import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GrievanceDashboardService {

  private dataSubject = new BehaviorSubject<any>(this.getData());
  data$ = this.dataSubject.asObservable();

  // HEADER AND SIDE BAR CHANGE CSS //

  private collapsed = new BehaviorSubject<boolean>(false);
  collapsed$ = this.collapsed.asObservable();

  toggleCollapse() {
    this.collapsed.next(!this.collapsed.value);
  }

  // MAIN COMPONENT CSS WIDTH CHANGE //

  private widthSubject = new BehaviorSubject<any>('100%');
  width$ = this.widthSubject.asObservable();

  updateWidth(width: any) {
    this.widthSubject.next(width);
  }

  //CHANGE SIDE BAR MENU LIST //

  // private viewSubject = new BehaviorSubject<string>('grievance');
  private viewSubject = new BehaviorSubject<string>('');
  view$ = this.viewSubject.asObservable();

  setView(viewName: string) {
    localStorage.setItem('routeNames', viewName);
    this.viewSubject.next(viewName);
  }

  token = ''
  data: any;
  constructor(private http: HttpClient) { }

  getCountDetails() {
    //  this.token=localStorage.getItem('token')
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(environment.printasseturl + "/employee/api/jwtV2/grevience/grievanceCount", { headers });
  }

  getGrievanceDetails() {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(environment.printasseturl +"/employee/api/jwtV2/grevience/grievanceDetails", { headers });
  }

  getGrievanceStatus(uniqueRef: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/grevience/grievanceDetailsByStatus?grievanceId=' + uniqueRef, { headers });
  }

  postGrievance(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token
    });
    return this.http.post(environment.printasseturl + '/employee/api/jwtV2/grevience/saveTrackDetails', payload, { headers });
  }
  // getstudentDownlod(admNo: any, fileName: any): Observable<HttpResponse<Blob>>  {
  //    const headers = new HttpHeaders({
  //    'Authorization': `${this.token}`
  //   });
  //   return this.http.get(environment.printasseturl + '/employee/api/jwtV2/student/downloadGrievanceDoc?admNo=' + admNo + '&' + 'fileName=' + fileName, { headers, responseType: 'blob' },)

  // }

  getstudentDownlod(admNo: any, filename: any): Observable<HttpResponse<Blob>> {
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${this.token}` });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/student/downloadGrievanceDoc?admNo=' + admNo + '&' + 'fileName=' + filename, {
      headers,
      responseType: 'blob',
      observe: 'response'
    });
  }

  getEmployeeDetails(emp: any, campusid: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/employee/currentEmployeeSearchByKeys?searchCriteria=' + emp + '&campusId=' + campusid, { headers });
  }

  setData(data: any) {
    this.dataSubject.next(data);
    localStorage.setItem('grievanceData', JSON.stringify(data));
  }
  getData() {
    const stored = localStorage.getItem('grievanceData');
    return stored ? JSON.parse(stored) : null;
  }

  getGrievanceReport(payrollId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/grevience/grievanceReport?payrollId=' + payrollId, { headers });
  }

  getRolemanagement(payrollId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/common/userRoles?payrollId=' + payrollId, { headers });
  }


}
